/*
 * 企業側 案件詳細（条件相談）
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_NEGOTIATE_MESSAGE = 'API_UPDATE_CLIENT_NEGOTIATE_MESSAGE';
/**
 * 条件相談メッセージの更新
 */
export const apiUpdateClientNegotiateMessage = ({ json, path: { id, view_request_id: viewRequestId } }, meta) => apiUpdate(API_UPDATE_CLIENT_NEGOTIATE_MESSAGE, `/client/rfp/${id}/negotiate/${viewRequestId}/message`, json, Object.assign(Object.assign({}, meta), { id, viewRequestId }));
